import { RedirectState } from '@neo.tax/shared';

export const useSredHomeRedirect = (): RedirectState => ({ isLoading: false });
